module.exports = __webpack_public_path__ + "media/images/products/wedding/img-feature-safe-d27f16226304e091c3b5f140de95ff15.png";